import './NotificationContent.scss';
import {i18n, k} from '@i18n/translate';
import {message} from 'antd';
import {COLORS} from '@utils/constants';

const NotificationContent = (msgStr, link?, linkName?) => {
  return (
    <figure
      role="alert"
      aria-live="assertive"
      tab-index="0"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 0,
      }}>
      <figcaption>{msgStr}</figcaption>
      <button
        onClick={() => {
          message.destroy();
        }}
        style={{color: COLORS.Blue100}}
        className="btn-dismiss">
        {i18n.t(k.CTA__DISMISS).toLocaleUpperCase()}
      </button>

      {link && (
        <a
          onClick={() => {
            message.destroy();
          }}
          href={link}
          className="btn-link">
          {linkName}
        </a>
      )}
    </figure>
  );
};

export default NotificationContent;
